// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WinBackPing-cls1___9054aed693cc0a29ae1{/*!*/}.WinBackPing-cls2__d2f2b2f7e1eeb3cb73b1{display:flex;flex-wrap:wrap;justify-content:center;font-size:16px;line-height:22px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "WinBackPing-cls1___9054aed693cc0a29ae1",
	"cls2": "WinBackPing-cls2__d2f2b2f7e1eeb3cb73b1 WinBackPing-cls1___9054aed693cc0a29ae1"
};
export default ___CSS_LOADER_EXPORT___;
